export const truncate = (value: string, limit: number): string => {
  if (value.length <= limit) {
    return value;
  }

  const substring = value.substring(0, limit);
  const index = substring.lastIndexOf(' ');
  return value.substring(0, index) + '...';
};

export const formatDate = (isoDateTime: string): string => {
  const [date] = isoDateTime.split('T');
  return date.split('-').reverse().join('/');
};

export const slugify = (param: string): string => {
  return param.replace(/\s+/g, '-').toLowerCase();
};

export const stripHtml = (html: string): string => {
  if (!html) return '';
  const formatted = html.replace(/<\/(p|div|li|h[1-6])>/gi, ' ').replace(/<br\s*\/?>/gi, ' ');

  if (typeof window !== 'undefined' && typeof DOMParser !== 'undefined') {
    try {
      const doc = new DOMParser().parseFromString(formatted, 'text/html');
      return (doc.body.textContent || '').replace(/\s+/g, ' ').trim();
    } catch {
      // fallback
    }
  }
  return formatted
    .replace(/<[^>]*>/g, '')
    .replace(/\s+/g, ' ')
    .trim();
};
